export default __webpack_public_path__ + "static/media/bruzel.56d045e7.jpg";